import React from "react";
import { SingleFieldStep } from "./SingleFieldStep";

interface Props {
  onNextStep: (orgName: string) => void;
  onPreviousStep: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  initialValue?: string;
}

export const OrgName = ({
  onNextStep,
  onPreviousStep,
  initialValue,
}: Props) => (
  <SingleFieldStep
    titleKey="attraction.onboard.org_name.title"
    fieldName="organizationName"
    labelKey="attraction.onboard.org_name.label"
    submitLabelKey="sign_in.continue"
    dataTestPrefix="onboard.orgName"
    onNextStep={onNextStep}
    onPreviousStep={onPreviousStep}
    initialValue={initialValue}
  />
);
